import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	panelInnerTheme: {
		...shorthands.padding('16px'),
		backgroundColor: tokens.colorNeutralBackground1,
	},
});
export default useStyles;
